import { initializeApp, getApps, getApp } from 'firebase/app';
import { getFirestore, initializeFirestore, persistentLocalCache } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyBBXOMQXXqZGsjwjcwx03cuicXbMKXE2l4",
  authDomain: "teklif-portali-f3c1f.firebaseapp.com",
  projectId: "teklif-portali-f3c1f",
  storageBucket: "teklif-portali-f3c1f.firebasestorage.app",
  messagingSenderId: "286362469458",
  appId: "1:286362469458:web:bdb60a8935b75e4952cb8b"
};

export const isFirebaseConfigured = true;

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

let firestoreDb;
try {
  firestoreDb = initializeFirestore(app, {
    localCache: persistentLocalCache()
  });
} catch (e) {
  firestoreDb = getFirestore(app);
}
export const db = firestoreDb;
export const auth = getAuth(app);
export { firebaseConfig };
